/* PLAYIO drawer re-render — setHTMLUnsafe in-place (zastępuje outerHTML morph) */
(function () {
  if (window.__playioDrawerMorphInit) return;
  window.__playioDrawerMorphInit = true;
  var HOST = 'cart-items-component';
  var forcing = false;

  function liveHost() {
    return document.querySelector('cart-drawer-component ' + HOST) || document.querySelector(HOST);
  }

  function rerender(detail) {
    try {
      var sections = detail && detail.data && detail.data.sections;
      if (!sections) return;
      var drawerHtml = null;
      for (var k in sections) {
        var h = sections[k];
        if (typeof h === 'string' && h.indexOf('cart-drawer-v2') !== -1) { drawerHtml = h; break; }
      }
      if (!drawerHtml) return;

      var live = liveHost();
      if (!live || typeof live.setHTMLUnsafe !== 'function') return;

      var fresh = new DOMParser().parseFromString(drawerHtml, 'text/html').querySelector(HOST);
      if (!fresh) return;

      live.setHTMLUnsafe(fresh.innerHTML);   // host zostaje; dzieci od nowa → delegacja +/−/kosz/karuzela żyje
    } catch (err) {
      console.warn('[playio-drawer] rerender error:', err);
    }
  }

  // Dociągnij ŚWIEŻE sekcje z serwera i odśwież drawer. Dla mutacji koszyka które NIE niosą
  // sekcji w evencie: cross-sell „+" oraz gift z playio-upsell.js (addGift przez origFetch).
  // Wystawione globalnie dla upsell.js i delegacji cross-sell niżej.
  async function forceRerenderFromServer() {
    if (forcing) return;
    forcing = true;
    try {
      // Refresh EVERY cart-items-component on the page — the drawer AND the /cart
      // page list. (cart-drawer-component lives in the layout on every page, so the
      // old liveHost()-only path kept morphing the hidden drawer while the visible
      // /cart list never updated after a gift/cross-sell auto-add.) Each host has
      // its own section id, so we ask the server for all of them in one request and
      // morph each from its own fresh HTML.
      var hosts = Array.prototype.slice.call(document.querySelectorAll(HOST)).filter(function (el) {
        return el.isConnected
          && typeof el.setHTMLUnsafe === 'function'
          && (el.dataset.sectionId || el.getAttribute('data-section-id'));
      });
      if (!hosts.length) return;

      var ids = [];
      hosts.forEach(function (el) {
        var id = el.dataset.sectionId || el.getAttribute('data-section-id');
        if (ids.indexOf(id) === -1) ids.push(id);
      });

      var url = (window.location.pathname || '/') + '?sections=' + encodeURIComponent(ids.join(','));
      var res = await fetch(url, { credentials: 'same-origin' });
      var json = await res.json();

      hosts.forEach(function (el) {
        try {
          var id = el.dataset.sectionId || el.getAttribute('data-section-id');
          var html = json && json[id];
          if (typeof html !== 'string') return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(HOST);
          if (fresh) el.setHTMLUnsafe(fresh.innerHTML);
        } catch (e) {
          console.warn('[playio-drawer] morph host error:', e);
        }
      });

      // Notify ship-bar / upsell (progress re-render). Marked __playioForce so the
      // listener below does NOT re-morph (we already did it directly above).
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { sections: json }, source: 'playio-force', __playioForce: true }
      }));
    } catch (err) {
      console.warn('[playio-drawer] force rerender error:', err);
    } finally {
      forcing = false;
    }
  }
  window.__playioForceRerender = forceRerenderFromServer;

  document.addEventListener('cart:update', function (e) {
    var detail = e.detail;
    var force = detail && (detail.__playioForce || detail.source === 'playio-force');
    Promise.resolve().then(function () {          // po synchronicznym morphSection Horizona
      if (force) return;                          // forceRerenderFromServer już zmorfował hosty bezpośrednio
      var sections = detail && detail.data && detail.data.sections;
      if (sections && Object.keys(sections).length) {
        rerender(detail);                         // natywny / nasz dispatch z sekcjami (drawer)
      } else {
        forceRerenderFromServer();                // np. cross-sell data:{} → dociągnij sekcje i odśwież
      }
    });
  });
  console.log('[playio-drawer] re-render: setHTMLUnsafe in-place aktywny');
})();

/* PLAYIO drawer — delegacja klików +/−/kosz + cross-sell „+" (Plan B; Horizon nie ożywia bindów po re-renderze) */
(function () {
  if (window.__playioDrawerDelegInit) return;
  window.__playioDrawerDelegInit = true;

  var DRAWER_HOST = 'cart-drawer-component cart-items-component';
  var SEL_PLUS   = 'button[name="plus"]';
  var SEL_MINUS  = 'button[name="minus"]';
  var SEL_REMOVE = 'button.cart-items__remove';
  var SEL_ANY    = SEL_PLUS + ', ' + SEL_MINUS + ', ' + SEL_REMOVE;
  var SEL_CROSS  = 'button.playio-cart-carousel__add, [data-playio-cart-add]';
  var busy = false;

  function host() { return document.querySelector(DRAWER_HOST); }

  function sectionId() {
    var h = host();
    return (h && (h.dataset.sectionId || h.getAttribute('data-section-id'))) || '';
  }

  // Horizon binduje on:click globalnie w capture (component.js → registerEventListeners). Po
  // re-renderze nowy quantity-selector-component nie jest żywym Component → instanceof Component
  // fałsz → natywny handler milczy. Zdejmujemy on:click z guzików drawera TYLKO po re-renderze
  // (MutationObserver) → natywny robi no-op (brak atrybutu = getElement zwraca null), a delegacja
  // przejmuje klik. Na świeżym (działającym) renderze on:click zostaje → oddajemy natywnemu.
  function neutralize() {
    var h = host();
    if (!h) return;
    // +/−/kosz ORAZ disclosure-trigger (rabat/notatka — on:click="/toggleDisclosure", martwy po re-renderze)
    var b = h.querySelectorAll(SEL_ANY + ', .disclosure-trigger');
    for (var i = 0; i < b.length; i++) {
      if (b[i].hasAttribute('on:click')) b[i].removeAttribute('on:click');
    }
  }

  async function change(key, quantity) {
    if (busy) return;
    busy = true;
    try {
      var sid = sectionId();
      var body = { id: key, quantity: quantity };
      if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await res.json();
      // odpal istniejący flow: re-render (setHTMLUnsafe, wyżej) + gift/ship-bar (playio-upsell.js)
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { sections: (data && data.sections) || {} }, source: 'playio-deleg' }
      }));
    } catch (err) {
      console.warn('[playio-drawer] deleg change error:', err);
    } finally {
      busy = false;
    }
  }

  // cross-sell „Dorzuć do paczki": snippetowy <script> nie wykonuje się po setHTMLUnsafe (i nie
  // istnieje gdy koszyk był pusty na starcie) → listener __playioCarouselAddBound bywa nieobecny.
  // Przejmujemy add tu (trwała delegacja). Brak sekcji w /cart/add.js → forceRerenderFromServer.
  async function addCross(btn, variantId) {
    if (busy) return;
    busy = true;
    var orig = btn.textContent;
    try { btn.disabled = true; btn.textContent = '✓'; } catch (e) {}
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (typeof window.__playioForceRerender === 'function') {
        await window.__playioForceRerender();
      } else {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {}, source: 'playio-deleg-cross' } }));
      }
    } catch (err) {
      console.warn('[playio-drawer] cross-sell add error:', err);
    } finally {
      busy = false;
      setTimeout(function () { try { btn.disabled = false; btn.textContent = orig; } catch (e) {} }, 600);
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    // cross-sell „+" (karuzela). Guard: jeśli snippetowy listener żyje → oddaj jemu (anti-double-add).
    var add = e.target.closest(SEL_CROSS);
    if (add) {
      if (!add.closest(DRAWER_HOST)) return;
      if (window.__playioCarouselAddBound) return;
      var vid = add.getAttribute('data-playio-cart-add') || add.dataset.playioCartAdd;
      if (!vid) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addCross(add, vid);
      return;
    }

    // discount / cart-note disclosure (Horizon on:click="/toggleDisclosure"). Native disclosure-custom
    // bywa martwy po re-renderze (i niepewny na mobile) → obsługujemy ZAWSZE sami. Strip on:click,
    // żeby natywny handler nie wystrzelił (brak atrybutu = getElement→null) → bez double-toggle.
    var trig = e.target.closest('.disclosure-trigger');
    if (trig && trig.closest(DRAWER_HOST)) {
      trig.removeAttribute('on:click');
      e.preventDefault();
      e.stopImmediatePropagation();
      var dc = trig.closest('disclosure-custom') || trig.parentElement;
      var content = dc && dc.querySelector('.disclosure-content');
      var open = trig.getAttribute('aria-expanded') === 'true';
      trig.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (content) {
        // inert + jawne grid-template-rows. 'auto' niezawodnie pokazuje treść (CSS 0fr→1fr bywa 0 na WebKit);
        // przy zamknięciu czyścimy inline → wraca reguła [inert]{0fr}. Bezpieczne na każdym silniku.
        if (open) { content.setAttribute('inert', ''); content.style.gridTemplateRows = ''; }
        else { content.removeAttribute('inert'); content.style.gridTemplateRows = 'auto'; }
      }
      return;
    }

    // +/−/kosz
    var btn = e.target.closest(SEL_ANY);
    if (!btn || !btn.closest(DRAWER_HOST)) return;     // tylko guziki w drawerze
    if (btn.hasAttribute('on:click')) return;          // native żywy (świeży render) → oddaj natywnemu

    var row = btn.closest('[data-key]');               // <tr ... data-key="{{ item.key }}">
    var key = row && row.getAttribute('data-key');
    if (!key) { console.warn('[playio-drawer] deleg: brak data-key'); return; }

    e.preventDefault();
    e.stopImmediatePropagation();                      // ubij ewentualny natywny capture-handler

    var next;
    if (btn.matches(SEL_REMOVE)) {
      next = 0;
    } else {
      var inp = row.querySelector('input[name="updates[]"], [ref="quantityInput"]');
      var qty = inp ? parseInt(inp.value, 10) : NaN;
      if (isNaN(qty)) { console.warn('[playio-drawer] deleg: brak qty'); return; }
      next = btn.matches(SEL_MINUS) ? Math.max(0, qty - 1) : qty + 1;
    }
    change(key, next);
  }, true);                                            // ⬅ capture

  // disclosure (rabat/notatka): obsługujemy zawsze sami → proaktywny strip on:click (init + każdy render),
  // żeby native nigdy nie dublował i żeby działało niezależnie od żywotności disclosure-custom (mobile!).
  function stripDisclosureTriggers() {
    var h = host();
    if (!h) return;
    var b = h.querySelectorAll('.disclosure-trigger');
    for (var i = 0; i < b.length; i++) {
      if (b[i].hasAttribute('on:click')) b[i].removeAttribute('on:click');
    }
  }
  stripDisclosureTriggers();

  // strip on:click PO każdym re-renderze (setHTMLUnsafe / native morph podmienia dzieci hosta)
  var h0 = host();
  if (h0 && window.MutationObserver) {
    new MutationObserver(function () { neutralize(); stripDisclosureTriggers(); }).observe(h0, { childList: true, subtree: true });
  } else {
    document.addEventListener('cart:update', function () { setTimeout(function () { neutralize(); stripDisclosureTriggers(); }, 0); });
  }

  console.log('[playio-drawer] delegacja +/−/kosz + cross-sell aktywna');
})();
